import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { EditBoxSVG } from '@common_components/svg/editBox.svg';

const EditBoxIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <EditBoxSVG/>
    </div>
  );
};

export { EditBoxIcon };
